import useCollections from "@hooks/useCollections";

/**
 * 컬렉션 상품 목록. Shopify 쿼리를 쓴다.
 *
 * 컬렉션은 머천다이징 순서와 필터 개수가 화면의 핵심인데 그건 Shopify 응답이 정답이다.
 * (상품 레코드에 collections 색인도 없어서 Algolia 로는 컬렉션 조회 자체가 안 된다.) 검색만 Algolia 를 쓴다.
 */
export default function useCollectionsData() {
  return useCollections();
}
